var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopDownArrowD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.78 34L17 31.2 38 10l21 21.2-2.77 2.8L38 15.6 19.78 34zM38 60.4L19.78 42 17 44.8 38 66l21-21.2-2.77-2.8L38 60.4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top-down_arrow_D.906a30be.svg";
export { SvgJ1TopDownArrowD as ReactComponent };